export default __webpack_public_path__ + "assets/img_webp/back_icon_n_item_06.fe48249d.png";